import React, { useEffect } from "react";

import SiteCustomerSupportComponent from "../../components/site/home/site-customer-support.component";
import SiteFindBestPlanComponent from "../../components/site/home/site-find-best-plan.component";
import SiteSocialNetworkComponent from "../../components/site/home/site-social-network.component";

const Plans = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClick = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="plan-page">
      <SiteFindBestPlanComponent />
      <SiteCustomerSupportComponent onClick={onClick} />
      <SiteSocialNetworkComponent />
    </div>
  );
};

export default Plans;
